import KeyboardTabIcon from "@mui/icons-material/KeyboardTab";
import MuiDrawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import Slide, { SlideProps } from "@mui/material/Slide";
import { styled } from "@mui/material/styles";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import ChatWindow from "messaging/forums/_views/components/forum-chat-window";
import Forum from "messaging/forums/forum";

const Drawer = styled(MuiDrawer)(({ theme }) => ({
  width: "min(400px, 100vw)",
  flexShrink: 0,
  "& .MuiDrawer-paper": {
    overflowX: "hidden",
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(8),
    width: "min(400px, 100vw)",
    boxSizing: "border-box",
  },
}));
const CommentsPanel = styled(Drawer, { shouldForwardProp: (prop) => prop !== "closeAfterTransition" })(() => ({
}));
const CommentsPanelContainer = styled("div")(() => ({
  flex: 1,
  height: "100%",
}));
const CommentsPanelContent = styled("div")(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    paddingTop: 0,
  },
  display: "flex",
  flexDirection: "column",
  height: "100%",
  minHeight: 0,
  padding: theme.spacing(2),
  width: "400px",
}));
const TitleBar = styled("div")(({ theme }) => ({
  alignItems: "center",
  display: "flex",
  justifyContent: "space-between",
  flexDirection: "row",
  paddingBottom: theme.spacing(1),
}));
const DrawerChatWindow = styled(ChatWindow)(() => ({
  flex: 1,
  height: "100%",
  maxHeight: "none",
  minHeight: 0,
}));
function RightAnchoredDrawerSlide(props: Readonly<SlideProps>) {
  return <Slide {...props} direction="left" />;
}

type CommentsDrawerProps = {
  forums: Forum[];
  readOnly?: boolean;
  isOpen: boolean;
  isOverlay?: boolean;
  onClose: () => void;
};

export default function CommentsDrawer(props: Readonly<CommentsDrawerProps>) {
  const {
    forums,
    readOnly,
    isOpen,
    isOverlay,
    onClose
  } = props;

  return (
    <CommentsPanel
      key={isOverlay ? "overlay" : "persistent"}
      open={isOpen}
      anchor="right"
      variant={isOverlay ? "temporary" : "persistent"}
      closeAfterTransition={false}
      ModalProps={{ keepMounted: true }}
      slots={{
        transition: RightAnchoredDrawerSlide,
      }}
      onClose={onClose}
    >
      <CommentsPanelContainer>
        <CommentsPanelContent>
          <TitleBar>
            <Typography variant="h5">Messages</Typography>
            <Tooltip title="Minimize messages panel">
              <IconButton size="medium" onClick={onClose}>
                <KeyboardTabIcon fontSize="large" />
              </IconButton>
            </Tooltip>
          </TitleBar>
            <DrawerChatWindow forums={forums} readOnly={readOnly} />
        </CommentsPanelContent>
      </CommentsPanelContainer>
    </CommentsPanel>
  );
}
